import { render, staticRenderFns } from "./RD25.vue?vue&type=template&id=5c15d77c&scoped=true"
import script from "./RD25.vue?vue&type=script&lang=js"
export * from "./RD25.vue?vue&type=script&lang=js"
import style0 from "./RD25.vue?vue&type=style&index=0&id=5c15d77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15d77c",
  null
  
)

export default component.exports